import ajaxJson from "./ajax.js";
import dataPool from "./data.js";

//获取期次信息列表
export const getExamPeriodInfoList = (data) => {
  return ajaxJson(dataPool.getExamPeriodInfoList, data);
};
//获取获取试卷信息
export const getQuestionList = (data) => {
  return ajaxJson(dataPool.getQuestionList, data, 'POST');
};
//获取模拟试卷信息的答案及解析
export const getExamineTestAnswer = (data) => {
  return ajaxJson(dataPool.getExamineTestAnswer, data);
};
//提交答案信息
export const submitPCExamineUserAnswer = (data) => {
  return ajaxJson(dataPool.submitPCExamineUserAnswer, data, 'POST');
};
//提交试卷信息，返回考核成绩及考核结果
export const submitPCExamine = (data) => {
  return ajaxJson(dataPool.submitPCExamine, data);
};
//获取身份证号关联的期次信息列表
export const getIDCardRelevanceExamPeriodInfoList = (data) => {
  return ajaxJson(dataPool.getIDCardRelevanceExamPeriodInfoList, data, "POST");
};
export const getIdCardRsaKey = () => {
  return ajaxJson(dataPool.getIdCardRsaKey);
};


// WEBPACK FOOTER //
// ./src/api/index.js